/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

import { Alert } from '@zapier/design-system';
import type { ResponseData } from '../useAlertBanner/useAlertBannerData';

import { BannerProps } from './types';

const Styles = labelStyles('BannerMessage', {
  content: css`
    display: inline-block;

    // Reset styles lifted from @zapier/style-encapsulation package.
    * {
      all: unset;
      box-sizing: border-box;
      -webkit-text-fill-color: currentColor;
    }
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
    a {
      cursor: pointer;
      text-decoration: underline;
    }
  `,
});

export const shouldRender = (data: ResponseData) => {
  return !!data.currentUser.bannerMessage;
};

export const Component = function BannerMessage(props: BannerProps) {
  const content = (
    <div
      css={Styles.content}
      dangerouslySetInnerHTML={{
        __html: props.data.currentUser.bannerMessage!,
      }}
      data-zds
    />
  );
  return (
    <Alert
      ariaLive="polite"
      layout={props.layout}
      title={content}
      type="info"
    />
  );
};
